const cellCalcPercent = (val, total) =>  `${(val / total * 100).toFixed(2)}%`;
const cellValAndCalcPercent = (val, total) =>  `${val} - ${cellCalcPercent(val, total)}`;

export const operations = [{
    label: 'SUM',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => (+value || 0).toFixed(2)
  }, {
    label: 'COUNT',
    operation: 'COUNT',
    cellGetter: (value, rowTotal, colTotal, total) => (+value || 0).toFixed(2)
  }, {
    label: 'SUM ALL, %',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => cellCalcPercent(value, total)

  }, {
    label: 'SUM ALL, value and %',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => cellValAndCalcPercent(value, total)

  }, {
    label: 'COUNT ALL, %',
    operation: 'COUNT',
    cellGetter: (value, rowTotal, colTotal, total) => cellCalcPercent(value, total)
  }, {
    label: 'COUNT ALL, value and %',
    operation: 'COUNT',
    cellGetter: (value, rowTotal, colTotal, total) => cellValAndCalcPercent(value, total)
  }, {
    label: 'SUM ROW, %',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => cellCalcPercent(value, rowTotal)

  }, {
    label: 'SUM ROW, value and %',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => cellValAndCalcPercent(value, rowTotal)

  }, {
    label: 'COUNT ROW, %',
    operation: 'COUNT',
    cellGetter: (value, rowTotal, colTotal, total) => cellCalcPercent(value, rowTotal)
  }, {
    label: 'COUNT ROW, value and %',
    operation: 'COUNT',
    cellGetter: (value, rowTotal, colTotal, total) => cellValAndCalcPercent(value, rowTotal)
  }, {
    label: 'SUM COLUMN, %',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => cellCalcPercent(value, colTotal)

  }, {
    label: 'SUM COLUMN, value and %',
    operation: 'SUM',
    cellGetter: (value, rowTotal, colTotal, total) => cellValAndCalcPercent(value, colTotal)

  }, {
    label: 'COUNT COLUMN, %',
    operation: 'COUNT',
    cellGetter: (value, rowTotal, colTotal, total) => cellCalcPercent(value, colTotal)
}, {
  label: 'COUNT COLUMN, value and  %',
  operation: 'COUNT',
  cellGetter: (value, rowTotal, colTotal, total) => cellValAndCalcPercent(value, colTotal)
}];